import { Dialog } from "primereact/dialog";
import { GeneratedBranchInvoice } from "./GeneratedBranchImvoice";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVDropdown } from "../../shared/JVDropdown";

interface IProps {
    open: boolean;
    onClose: () => void;
    singleData?: GeneratedBranchInvoice;
    toast: any;
}

const schema = yup.object({
    payment_Status: yup.string().required("Payment Status is required"),
    payment_Received_Amount: yup.number().required("Payment Received Amount is required").positive("Payment Received Amount must be positive").typeError("Payment Received Amount must be a number"),
});

const Payment_Status = [
    { name: "-- SELECT --", value: null },
    { name: "Pending", value: "Pending" },
    { name: "Paid", value: "Paid" },
    { name: "Balance", value: "Balance" },
    { name: "Over Payment", value: "Over Payment" },
];

export const BranchInvoice = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<GeneratedBranchInvoice>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onSubmit = async (data: GeneratedBranchInvoice) => {
        const newData: GeneratedBranchInvoice = {
            id: props.singleData?.id,
            payment_Status: data.payment_Status,
            payment_Received_Amount: data.payment_Received_Amount,
        };

        if (newData.payment_Status === "Paid" && Number(newData.payment_Received_Amount || 0) !== Number(props.singleData?.branchInvoiceAmount || 0)) {
            props.toast.current?.show({ severity: 'error', detail: "Received Amount dose not match to Payment Status and Invoice Amount", life: 3000 });
        } else if (newData.payment_Status === "Balance" && Number(newData.payment_Received_Amount || 0) >= Number(props.singleData?.branchInvoiceAmount || 0)) {
            props.toast.current?.show({ severity: 'error', detail: "Received Amount dose not match to Payment Status and Invoice Amount", life: 3000 });
        } else if (newData.payment_Status === "Over Payment" && Number(newData.payment_Received_Amount || 0) <= Number(props.singleData?.branchInvoiceAmount || 0)) {
            props.toast.current?.show({ severity: 'error', detail: "Received Amount dose not match to Payment Status and Invoice Amount", life: 3000 });
        } else {
            setLoading(true);
            const response = await Fetch("InvoiceTracking/updateInvoiceGeneratedBranchWiseIncentiveCalculation", "PUT", newData, null, props.toast);
            if (response) {
                setLoading(false);
                hideDialog();
                props.toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Follow Up Call History Added Successfully' });
            } else {
                setLoading(false);
                props.toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to Add Follow Up Call History' });
            }
        }
    }

    const hideDialog = () => {
        props.onClose();
    };

    useEffect(() => {
        if (props.open && props.singleData) {
            setValue("payment_Status", props.singleData.payment_Status);
            setValue("payment_Received_Amount", props.singleData.payment_Received_Amount);
        }
    }, [props.open]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '60vw' }} className="p-fluid" header="Update Invoice Payment" onHide={hideDialog} draggable={false}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVDropdown column={2} label="Payment Status" control={control} name="payment_Status" options={Payment_Status} optionLabel="name" optionValue="name" placeholder="Select Payment Status" error={errors.payment_Status?.message} />
                    <JVInput required column={2} label="Payment Received Amount" control={control} name="payment_Received_Amount" error={errors.payment_Received_Amount?.message} />
                    <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                        <Button loading={loading} disabled={loading} label="SAVE" type={loading === false ? "submit" : "button"} style={{ width: '100px', height: "2.5rem", marginTop: "2rem" }} ></Button>
                        <Button className="p-button-outlined surface-200" style={{ width: '100px', height: "2.5rem", marginTop: "2rem" }} label="CLEAR" onClick={() => reset({})} type="button" ></Button>
                    </div>
                </form>
            </Dialog>
        </>
    );
}